<div class="cardmodal-container">

  <!-- Header -->
  <mat-card-header class="modal-header">
    <div class="header-content" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
        <div class="header-icon-circle">
          <mat-icon>verified</mat-icon>
        </div>
        <div>
          <h2 class="modal-title">Validation de la Compensation Fidélité</h2>
          <div class="modal-subtitle">Annulation et verrouillage direct sur le serveur central</div>
        </div>
      </div>
      <button mat-icon-button (click)="close()" title="Fermer">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-card-header>

  <div class="modal-body">

    <!-- Quota & Metrics Bar -->
    <div class="quota-bar" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="12px">
      <div class="quota-chip" [class.full]="getTotalTicketCount() === maxBasketSize">
        <mat-icon>confirmation_number</mat-icon>
        <span>Total Billets : <strong>{{ getTotalTicketCount() }}/{{ maxBasketSize }}</strong></span>
        <span class="quota-breakdown">({{ card.length }} numérique(s) VPS + {{ manualTicketsCount }} manuel(s))</span>
      </div>

      <div class="metrics-chips" fxLayout="row" fxLayoutGap="12px">
        <div class="stat-pill">
          <span class="stat-label">Total Dépensé</span>
          <span class="stat-value">{{ totalAmount | number }} FCFA</span>
        </div>
        <div class="stat-pill">
          <span class="stat-label">Prix Moyen / Trajet</span>
          <span class="stat-value highlight">{{ averageAmount | number }} FCFA</span>
        </div>
      </div>
    </div>

    <!-- Name Consistency Banner -->
    <div class="name-consistency-banner" [ngClass]="'status-' + nameConsistency.status" *ngIf="card.length > 0">
      <div class="consistency-icon">
        <mat-icon *ngIf="nameConsistency.status === 'exact'">check_circle</mat-icon>
        <mat-icon *ngIf="nameConsistency.status === 'variant'">published_with_changes</mat-icon>
        <mat-icon *ngIf="nameConsistency.status === 'conflict'">error_outline</mat-icon>
      </div>
      <div class="consistency-text">
        <div class="consistency-title">
          <strong *ngIf="nameConsistency.status === 'exact'">Identité vérifiée : Concordance parfaite des billets (100%)</strong>
          <strong *ngIf="nameConsistency.status === 'variant'">Variante de nom acceptée (Concordance {{ nameConsistency.score }}%)</strong>
          <strong *ngIf="nameConsistency.status === 'conflict'">Alerte : Billets appartenant à des passagers différents !</strong>
        </div>
        <div class="consistency-desc">
          {{ nameConsistency.message }}
        </div>
      </div>
      <div class="consistency-actions" *ngIf="nameConsistency.status === 'conflict'">
        <button mat-flat-button color="warn" class="btn-clean-basket" (click)="cleanBasketToPrimary()">
          <mat-icon>filter_alt</mat-icon>
          <span>Ne garder que "{{ nameConsistency.primaryName }}"</span>
        </button>
      </div>
    </div>

    <!-- Zero Price Alert Banner -->
    <div class="zero-price-alert-banner" *ngIf="zeroPriceTicketsCount > 0">
      <div class="zero-icon">
        <mat-icon>money_off</mat-icon>
      </div>
      <div class="zero-text">
        <div class="zero-title">
          <strong>Alerte : {{ zeroPriceTicketsCount }} billet(s) non éligible(s) à 0 FCFA détecté(s) !</strong>
        </div>
        <div class="zero-desc">
          Les billets gratuits ou à montant nul ne peuvent pas être pris en compte pour la fidélité. Ils doivent être retirés avant de pouvoir valider.
        </div>
      </div>
      <div class="zero-actions">
        <button mat-flat-button color="warn" class="btn-clean-zero" (click)="removeZeroPriceTickets()">
          <mat-icon>delete_sweep</mat-icon>
          <span>Retirer les billets à 0 FCFA</span>
        </button>
      </div>
    </div>

    <!-- Digital Tickets Table from VPS -->
    <div class="section-title" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-icon color="primary">cloud_done</mat-icon>
        <span>Billets numériques sélectionnés sur le VPS ({{ card.length }})</span>
      </div>
      <span *ngIf="nameConsistency.status === 'variant'" class="variant-chip">
        Variantes orthographiques acceptables
      </span>
    </div>

    <div class="mat-elevation-z2 table-wrap">
      <table mat-table [dataSource]="dataSource" matSort>

        <!-- No Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> N° </th>
          <td mat-cell *matCellDef="let element; let i=index;">
            <span class="index-badge">{{i+1}}</span>
          </td>
        </ng-container>

        <!-- Ticket Column -->
        <ng-container matColumnDef="ticket">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Billet </th>
          <td mat-cell *matCellDef="let row">
            <strong>{{row?.ticket2Display || row?.idpvDisplay || row?.idpv}}</strong>
          </td>
        </ng-container>

        <!-- Passenger Column -->
        <ng-container matColumnDef="passager_info">
          <th mat-header-cell *matHeaderCellDef> Passager </th>
          <td mat-cell *matCellDef="let row">
            <div class="passager-info">
              <span class="p-name">{{row?.passager?.nompassager}}</span>
              <span class="p-cni" *ngIf="row?.passager?.cni">CNI: {{row.passager.cni}}</span>
              <span class="p-phone" *ngIf="row?.passager?.contact"><mat-icon class="micro-icon">phone</mat-icon>{{row.passager.contact}}</span>
            </div>
          </td>
        </ng-container>

        <!-- Voyage Info Column -->
        <ng-container matColumnDef="voyage_info">
          <th mat-header-cell *matHeaderCellDef> Trajet &amp; Classe </th>
          <td mat-cell *matCellDef="let row">
            <div class="voyage-info">
              <span class="v-dest"><strong>{{row?.voyage?.agencedepart || ''}} ➔ {{row.destination?.nomdest}}</strong></span>
              <span class="v-meta">
                <span class="category-chip" [class.vip]="row?.voyage?.category?.nomcategory === 'VIP'">
                  {{row?.voyage?.category?.nomcategory || 'Classique'}}
                </span>
                Place {{row?.place}} — {{row.passager?.creationdate | date:"dd/MM/yyyy"}}
              </span>
            </div>
          </td>
        </ng-container>

        <!-- Tarif Column -->
        <ng-container matColumnDef="tarif">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Montant </th>
          <td mat-cell *matCellDef="let row">
            <span class="tarif-badge" [class.zero-tarif]="(row?.montant || 0) <= 0">
              {{(row?.montant || 0) | number}} FCFA
              <small *ngIf="(row?.montant || 0) <= 0" class="badge-zero-warn"> (Inéligible)</small>
            </span>
          </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button (click)="remove(element)" color="warn" title="Retirer du panier">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr class="mat-row empty-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <div class="empty-state">
              <mat-icon>remove_shopping_cart</mat-icon>
              <p>Votre panier est vide. Veuillez sélectionner des billets depuis la page de recherche.</p>
            </div>
          </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr class="example-element-row" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Manual Paper Tickets Complementary Section -->
    <div class="manual-tickets-card" *ngIf="card.length > 0 && card.length < maxBasketSize">
      <div class="manual-header" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-icon color="accent">receipt</mat-icon>
        <strong>Complément par billets physiques / manuels (Agences hors-ligne ou non synchronisées)</strong>
      </div>
      <div class="manual-desc">
        Le passager dispose de {{ card.length }} billet(s) numérique(s) sur le VPS. Vous pouvez compléter avec des billets papier vérifiés en main propre au guichet pour atteindre les 10 billets de fidélité.
      </div>

      <div class="manual-inputs-grid">
        <mat-form-field appearance="outline" class="manual-input-count">
          <mat-label>Nb. billets manuels papier</mat-label>
          <input
            matInput
            type="number"
            min="0"
            [max]="maxBasketSize - card.length"
            [(ngModel)]="manualTicketsCount"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="manual-input-refs">
          <mat-label>Références / N° des billets manuels papier vérifiés</mat-label>
          <input
            matInput
            [(ngModel)]="manualTicketsReferences"
            placeholder="Ex: Carnet BON-04512, BON-04513 (Agence Bonabéri)"
          />
          <mat-icon matPrefix>note_alt</mat-icon>
        </mat-form-field>
      </div>
    </div>

    <!-- Compensation Details Form -->
    <div class="compensation-form-box" *ngIf="card.length > 0">
      <div class="section-title" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-icon color="primary">card_giftcard</mat-icon>
        <span>Paramètres du Billet Gratuit Offert</span>
      </div>

      <div class="modal-form-grid">
        <!-- Nom bénéficiaire -->
        <mat-form-field appearance="outline" class="modal-field">
          <mat-label>Nom du Bénéficiaire</mat-label>
          <input matInput [(ngModel)]="beneficiaryName" placeholder="Nom complet" />
          <mat-icon matPrefix>person</mat-icon>
        </mat-form-field>

        <!-- CNI bénéficiaire -->
        <mat-form-field appearance="outline" class="modal-field">
          <mat-label>N° CNI / Passeport</mat-label>
          <input matInput [(ngModel)]="beneficiaryCni" placeholder="Numéro de pièce" />
          <mat-icon matPrefix>badge</mat-icon>
        </mat-form-field>

        <!-- Téléphone -->
        <mat-form-field appearance="outline" class="modal-field">
          <mat-label>Téléphone</mat-label>
          <input matInput [(ngModel)]="beneficiaryPhone" placeholder="Ex: 670123456" />
          <mat-icon matPrefix>phone</mat-icon>
        </mat-form-field>

        <!-- Destination offerte -->
        <mat-form-field appearance="outline" class="modal-field">
          <mat-label>Destination Offerte (Suggéré)</mat-label>
          <mat-select [(ngModel)]="selectedDestinationName">
            <mat-option *ngFor="let dest of destinations" [value]="dest.nomdest">
              {{ dest.nomdest }}
            </mat-option>
          </mat-select>
          <mat-icon matPrefix>location_on</mat-icon>
        </mat-form-field>

        <!-- Catégorie offerte -->
        <mat-form-field appearance="outline" class="modal-field">
          <mat-label>Classe Offerte</mat-label>
          <mat-select [(ngModel)]="selectedCategory">
            <mat-option value="Classique">Classique</mat-option>
            <mat-option value="VIP">VIP</mat-option>
            <mat-option value="Prestige">Prestige</mat-option>
          </mat-select>
          <mat-icon matPrefix>airline_seat_recline_extra</mat-icon>
        </mat-form-field>

        <!-- Durée de validité -->
        <mat-form-field appearance="outline" class="modal-field">
          <mat-label>Validité du code gratuit</mat-label>
          <mat-select [(ngModel)]="validityDays">
            <mat-option [value]="30">30 jours</mat-option>
            <mat-option [value]="60">60 jours (Recommandé)</mat-option>
            <mat-option [value]="90">90 jours</mat-option>
          </mat-select>
          <mat-icon matPrefix>event_available</mat-icon>
        </mat-form-field>

        <!-- Commentaire / Notes -->
        <mat-form-field appearance="outline" class="modal-field-full">
          <mat-label>Commentaire d'audit / Justification</mat-label>
          <input matInput [(ngModel)]="comment" placeholder="Ex: Fidélité 10 voyages - Validé au guichet" />
          <mat-icon matPrefix>comment</mat-icon>
        </mat-form-field>
      </div>
    </div>

  </div>

  <!-- Modal Footer -->
  <div class="modal-footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button color="warn" (click)="empty()" [disabled]="card.length === 0 || isValidating">
      <mat-icon>delete_sweep</mat-icon>
      Vider le panier
    </button>

    <div fxLayout="row" fxLayoutGap="12px">
      <button mat-stroked-button (click)="close()" [disabled]="isValidating">
        Fermer
      </button>

      <button
        mat-raised-button
        color="primary"
        class="btn-confirm-compensation"
        (click)="validateCompensation()"
        [disabled]="card.length === 0 || isValidating || getTotalTicketCount() > maxBasketSize || !nameConsistency.isConsistent || zeroPriceTicketsCount > 0"
      >
        <mat-icon *ngIf="!isValidating">verified</mat-icon>
        <mat-spinner *ngIf="isValidating" diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
        <span>
          <ng-container *ngIf="isValidating">
            {{ 'LOYALTY.VALIDATING_ONLINE' | translate }}
          </ng-container>
          <ng-container *ngIf="!isValidating">
            {{ 'LOYALTY.CONFIRM_AND_VALIDATE_ONLINE' | translate: { total: getTotalTicketCount(), max: maxBasketSize } }}
          </ng-container>
        </span>
      </button>
    </div>
  </div>

</div>
